// @ts-nocheck
import React from 'react';
import {
    Typography,
    Button,
} from '@mui/material';
import AppDialog from '../../components/AppDialog';
import useWorkplaceTerm from '../../hooks/useWorkplaceTerm';
const JobsiteJoinModal = ({notification, open, toggleModal, }) => {
  const workplace = useWorkplaceTerm();
    if(!notification) notification={}
    return (
    <React.Fragment>
        <AppDialog
            open={open}
            onClose={()=> toggleModal(false)}
            title={`${workplace.noun} Invitation`}
            actions={
                <>
                    <Button onClick={()=> toggleModal(false)}>Cancel</Button>
                    <Button type="submit">Join</Button>
                </>
            }
        >
            <Typography sx={{ mb:2, color: 'text.secondary' }}>
                {notification.senderFirstName + ' ' + notification.senderLastName} invited you to a job site
            </Typography>
            Accept the swms document before you join the job site
        </AppDialog>
    </React.Fragment>
    );
};

export default JobsiteJoinModal;
